export default "__VITE_ASSET__j$Wxh1CZ__"